<script>
	import Entries from "./Entries.svelte";
	import { link, push } from "svelte-spa-router";

	export let params = {};

	async function getWishlist() {
		if (params.permission) {
			const res = await fetch(`/api/Wishlist/${params.permission}`);
			return await res.json();
		}

		return null;
	}

	async function createWishlist(target) {
		const res = await fetch(`/api/Wishlist`, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(target.value),
		});
		const result = await res.json();
		push(`/Wishlist/${result}`);		
	}

	let wl = getWishlist();
	let title = "Wunschliste";
	$: document.title = title;
	$: params.permission, (wl = getWishlist());
</script>

{#if params.permission}
	{#await wl}
		Lade Wunschliste
	{:then entry}
	{title = entry.wishlist.name}
		<h1>{entry.wishlist.name}</h1>

		{#if entry.permissions}
			{#each entry.permissions as permission}
				<p>
					<a
						href="/Wishlist/{permission.id}"
						use:link>{#if permission.isAdmin}
							Adminzugriff
						{:else}Gastzugriff{/if}</a>
				</p>
			{/each}
		{/if}
		<Entries isAdmin={entry.isAdmin} permission={params.permission} />
	{/await}
{:else}
	<h1>Neue Wunschliste anlegen</h1>
	<input
		type="text"
		on:keydown={(e) => e.key == 'Enter' && createWishlist(e.target)} />
{/if}
